var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2483 2H6.94576C6.39527 2 5.86732 2.21071 5.47806 2.58579C5.0888 2.96086 4.87012 3.46957 4.87012 4V20C4.87012 20.5304 5.0888 21.0391 5.47806 21.4142C5.86732 21.7893 6.39527 22 6.94576 22H19.3996C19.9501 22 20.4781 21.7893 20.8673 21.4142C21.2566 21.0391 21.4753 20.5304 21.4753 20V8L15.2483 2Z",
    stroke: "#2B8BFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.248 2V8H21.475",
    stroke: "#2B8BFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3241 13H9.02148",
    stroke: "#2B8BFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3241 17H9.02148",
    stroke: "#2B8BFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0971 9H10.0593H9.02148",
    stroke: "#2B8BFC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIc);
export default __webpack_public_path__ + "static/media/faq-ic.f7c60110d3ded011f85da861438e35d2.svg";
export { ForwardRef as ReactComponent };